import { useEffect, useState, type RefObject } from "react";

export function useNarrowScreen(containerRef?: RefObject<HTMLElement | null>) {
  const [narrow, setNarrow] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 639px)").matches,
  );
  useEffect(() => {
    const container = containerRef?.current;
    if (container) {
      const observer = new ResizeObserver(([entry]) => {
        if (entry.contentRect.width > 0)
          setNarrow(entry.contentRect.width < 640);
      });
      observer.observe(container);
      return () => observer.disconnect();
    }
    const query = window.matchMedia("(max-width: 639px)");
    const update = () => setNarrow(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, [containerRef]);
  return narrow;
}
